import { render, staticRenderFns } from "./ThemeSetup.vue?vue&type=template&id=71e918e5&scoped=true&"
import script from "./ThemeSetup.vue?vue&type=script&lang=js&"
export * from "./ThemeSetup.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSetup.vue?vue&type=style&index=0&id=71e918e5&lang=scss&scoped=true&"
import style1 from "./ThemeSetup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e918e5",
  null
  
)

export default component.exports